import { cn } from '@/lib/utils'
import Image from 'next/image'

interface BlogCardProps {
  title: string
  description: string
  imageUrl: string
  className?: string
  aspectRatio?: 'video' | 'square'
  imageFit?: 'cover' | 'contain'
}

export default function BlogCard({ 
  title, 
  description,
  imageUrl,
  className,
  aspectRatio = 'video',
  imageFit = 'cover'
}: BlogCardProps) {
  return (
    <div className={cn("mb-4 flex h-full w-full flex-col group", className)}>
      <div className={cn(
        "w-full bg-muted rounded-xl flex items-center justify-center text-muted-foreground text-sm relative overflow-hidden",
        aspectRatio === 'video' ? 'aspect-video' : 'aspect-square'
      )}>
        <Image
            src={imageUrl}
            alt={title}
            fill
            className={cn(imageFit === 'contain' ? 'object-contain' : 'object-cover', "transition-transform duration-200 group-hover:scale-105")}
        />
      </div>
      <div className="flex flex-1 flex-col justify-between gap-2 pt-6">
        <div className="flex flex-col gap-1">
          <h3 className="font-medium text-xl text-foreground group-hover:text-primary transition-colors line-clamp-2">
            {title}
          </h3>
          <p className="text-sm text-muted-foreground line-clamp-3">
            {description}
          </p>
        </div>
      </div>
    </div>
  )
}
